import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=97e5b802&scoped=true&"
import script from "./Clock.vue?vue&type=script&lang=ts&"
export * from "./Clock.vue?vue&type=script&lang=ts&"
import style0 from "./Clock.vue?vue&type=style&index=0&id=97e5b802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e5b802",
  null
  
)

export default component.exports